<div #content class="obg-m-updated-terms-and-conditions-container" data-test-id="update-terms-and-conditions">
	<div *ngIf="!showDeclinedWarning; else updatedTermsAndConditionsDeclined">
		<p
			class="obg-m-updated-terms-and-conditions-title"
			[innerHtml]="'terms-and-conditions.updated-title' | translate"
		></p>
		<p class="obg-m-updated-terms-and-conditions-message" [innerHtml]="messageKey | translate"></p>
		<ng-container *ngIf="summaryKey | translate as summary">
			<p
				*ngIf="summary !== summaryKey"
				class="obg-m-updated-terms-and-conditions-summary"
				[innerHtml]="summary"
			></p>
		</ng-container>
		<div class="validation-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>
		<div class="button-container">
			<a
				[obgRouteLink]="readMoreLinkRoute"
				test-id="read-more-terms-and-conditions-button"
				[target]="allLinksExternal ? '_blank' : null"
				*ngIf="!hideReadMore"
				color="transparent"
				class="read-more-button"
				mat-flat-button
				(click)="onReadMore()"
			>
				{{ 'terms-and-conditions.updated-read' | translate }}
			</a>
			<div class="action-buttons">
				<button
					test-id="decline-terms-and-conditions-button"
					*ngIf="isExtendedUi"
					color="primary"
					mat-flat-button
					(click)="onDecline()"
					[innerHtml]="'terms-and-conditions.updated-decline' | translate"
				></button>
				<button
					test-id="accept-terms-and-conditions-button"
					data-test-id="accept-terms-and-conditions-button"
					color="accent"
					mat-flat-button
					(click)="onAccept()"
				>
					{{ 'terms-and-conditions.updated-accept' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
<ng-template #updatedTermsAndConditionsDeclined>
	<p
		class="obg-m-updated-terms-and-conditions-title"
		[innerHtml]="'terms-and-conditions.decline-updated-title' | translate"
	></p>
	<p
		class="obg-m-updated-terms-and-conditions-message"
		[innerHtml]="'terms-and-conditions.decline-updated-message' | translate"
	></p>
	<form [formGroup]="declineFormGroup" (ngSubmit)="onConfirmDecline()">
		<mat-checkbox
			test-id="logout-warning-checkbox"
			[class.checkbox-required]="false"
			color="primary"
			required
			formControlName="logoutWarning"
		>
			<span [innerHtml]="'terms-and-conditions.logout-warning' | translate"></span>
		</mat-checkbox>

		<mat-checkbox
			test-id="close-account-warning-checkbox"
			color="primary"
			required
			[class.checkbox-required]="false"
			class="obg-m-updated-terms-and-conditions-close-account-warning"
			formControlName="closeAccountWarning"
		>
			<span [innerHtml]="'terms-and-conditions.close-account-warning' | translate"></span>
		</mat-checkbox>
		<div class="validation-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>
		<div class="button-container">
			<div class="action-buttons">
				<button
					test-id="cancel-decline-terms-and-conditions-button"
					color="transparent"
					class="read-more-button"
					mat-flat-button
					(click)="onCancelDecline()"
				>
					{{ 'general.go-back' | translate }}
				</button>
				<button
					test-id="submit-decline-terms-and-conditions-button"
					color="primary"
					mat-flat-button
					type="submit"
					[innerHtml]="'terms-and-conditions.updated-decline' | translate"
				></button>
			</div>
		</div>
	</form>
</ng-template>
